<template>
  <div class="develop base-pad">
    <div class="title">
      <img :src="zh_en == 'zh' ? STATICURL + bgimg.develop_bgimg : STATICURL + develop_bgimg_en"
        style="width: 100%;height: 100%;" alt="">

    </div>


    <div class="content">
      <div class="detail">

        <div class="titlebox">
          <div style="color: #8a2e26;font-size: 28px;font-weight: bold;">溯源开发</div>
          <div style="display: flex;">
            <div class="default" :class='activityIndex == index ? "activity" : ""' v-for="(item, index) in tabList"
              :key="index" @click="change(index)">{{ item }}</div>
          </div>

          <img src="@/static/images/cultureTitile.png" style="width: 100%;position: absolute;bottom: 0;left: 0;"
            mode="widthFix" />
        </div>

        <div class="contentbox">

          <div
            style="display: flex;flex-direction: column;justify-content: center;align-items: center;margin-bottom: 24px;">
            <div style="color: #181818; font-size: 28px;font-weight: 600;margin-bottom: 5px;margin-top: 15px;">{{
              tabList[activityIndex] }}</div>
            <div style="width: 82px;height: 7px;border-radius: 3px;background-color: #8a2e26;"></div>
          </div>




          <div v-if="activityIndex == 0">111</div>
          <div v-if="activityIndex == 1">222</div>
          <div v-if="activityIndex == 2">333</div>
          <div v-if="activityIndex == 3">444</div>

        </div>



      </div>

    </div>

    <HomeFooter />
  </div>
</template>

<script>
import HomeFooter from '@/components/HomeFooter.vue';
export default {
  data() {
    return {
      tabList: ['溯源开发', '种植基地', '养殖接地', '中药现代化'],
      activityIndex: 0,
    }
  },
  components: {
    HomeFooter
  },
  methods: {
    change(e) {
      this.activityIndex = e
    }
  }

}
</script>


<style lang="less" scoped>
.default {
  font-size: 15px;
  padding: 2px 0;
  display: flex;
  align-items: center;
  margin-left: 35px;
}

.activity {
  font-size: 17px;
  color: #8A2E26;
  border-bottom: 1px solid #8A2E26;
}

.content {
  width: 100%;
  padding: 48px;
  box-sizing: border-box;

  .detail {
    .titlebox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      padding-bottom: 30px;
    }

    width: 60%;
    margin: 0 auto;
  }
}

.develop {}

.title {
  width: 100%;
  height: 360px;
  background-color: #d3dce6;

}
</style>